import type { RouteLocation } from 'vue-router';
import { useGlobalStore } from '~/stores/global';
import { pagesWithoutSeoData } from '~/common/const';
import { useAnalyticsStore } from '~/stores/analytics';
import { useInteractiveStore } from '~/stores/interactive';

export default defineNuxtPlugin(() => {
  const interactiveStore = useInteractiveStore();
  const route = useRoute();
  const router = useRouter();
  const { isDesktop } = useDevice();
  const globalStore = useGlobalStore();
  if (interactiveStore.isPageSpeedBot) return;
  const analyticsStore = useAnalyticsStore();
  // сделать что б яндекс метрика не работало при прямых переходах (type-in) из линукса
  const noLinuxReferrer = () => {
    const referrer = route?.query?.utm_referrer || document.referrer;
    const userAgent = navigator.userAgent || '';
    if (
      !referrer &&
      userAgent &&
      userAgent.toLowerCase().includes('linux') &&
      isDesktop
    ) {
      return false;
    }
    return true;
  };

  const metrikaUrl = 'https://mc.yandex.ru/metrika/tag.js';
  const options = {
    id: '17022754',
    defer: true,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
    trackHash: true,
    ecommerce: 'dataLayer',
  };

  function init() {
    (function (m: any, e, t, r, i) {
      let k: any;
      let a: any;
      m[i] =
        m[i] ||
        function () {
          // eslint-disable-next-line prefer-rest-params
          (m[i].a = m[i].a || []).push(arguments);
        };
      // @ts-ignore
      m[i].l = 1 * new Date();
      // eslint-disable-next-line no-unused-expressions,no-sequences
      (k = e.createElement(t)),
        (a = e.getElementsByTagName(t)[0]),
        (k.async = 1),
        (k.src = r),
        a.parentNode.insertBefore(k, a);
    })(window, document, 'script', metrikaUrl, 'ym');
    // @ts-ignore
    ym(options.id, 'init', options);
    // @ts-ignore
    ym(options.id, 'hit', route.fullPath, {
      referer: route?.query?.utm_referrer || document.referrer,
    });

    const page =
      (pagesWithoutSeoData.find((pageName) => {
        const name = route.name as string;
        if (!name) return false;
        return name.search(pageName) !== -1;
      }) &&
        route.path.slice(1, -1).replace(/\//g, '-')) ||
      globalStore.seoData?.page?.type ||
      'unknown';
    // @ts-ignore
    ym(17022754, 'params', {
      page_type: page,
      vis: analyticsStore.session?.id,
      pv: analyticsStore.pageviewId,
      split: analyticsStore.additional.split,
    });
    // @ts-ignore
    ym(17022754, 'userParams', {
      UserID: analyticsStore.userId,
    });

    router.afterEach((to: RouteLocation, from: RouteLocation) => {
      if (from.name) {
        // @ts-ignore
        ym(options.id, 'hit', to.fullPath, {
          referer: from.fullPath,
        });

        const page =
          (pagesWithoutSeoData.find((pageName) => {
            const name = to.name as string;
            if (!name) return false;
            return name.search(pageName) !== -1;
          }) &&
            to.path.slice(1, -1).replace(/\//g, '-')) ||
          globalStore.seoData?.page?.type ||
          'unknown';
        // @ts-ignore
        ym(17022754, 'params', {
          page_type: page,
          vis: analyticsStore.session?.id,
          pv: analyticsStore.pageviewId,
          split: analyticsStore.additional.split,
        });
      }
    });
  }

  const runtimeConfig = useRuntimeConfig();
  const isProd = runtimeConfig.public.isProd;
  if (isProd && noLinuxReferrer() && !globalStore.webview) {
    interactiveStore.addFunction(init);
    return {
      provide: {
        ymInit: init,
      },
    };
  }
});
